module.exports = __webpack_public_path__ + "static/media/Intersection3.b62e1e4a.png";